// @flow

import * as React from 'react';
import LinkSwitcher from '../LinkSwitcher';
import Icon from '../Icon';

import type { IconType } from '../Icon';

type Props = {
    icon?: IconType,
    children?: any,
    [prop: string]: any
};

const Link = ({ icon, children, ...linkProps }: Props): React.Node => (
    <LinkSwitcher {...linkProps}>
        {icon && <Icon type={icon} className="Link__icon" />}
        {children}
    </LinkSwitcher>
);

export default Link;
